module.exports = __webpack_public_path__ + "assets/images/sample_4166f23427976cc142a6f3b6eecc4960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-1/sample.png
// module id = 253
// module chunks = 0